import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {
  Link,
  withRouter
} from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
import MuiDrawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DropDownIcon from '@material-ui/icons/ArrowDropDown';
import GraphIcon from '@material-ui/icons/Timeline';
import OstolaskuIcon from '@material-ui/icons/Receipt';
import KeyIcon from '@material-ui/icons/VpnKey';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';

import PercentIcon from '../../icons/percent.svg';
import Content from '../Content/Content';
import './Drawer.css';
import SvgIcon from '@material-ui/core/SvgIcon';


@inject('viewStore')
class DrawerListItem extends Component {

  handleClick = (e) => {
    const { viewStore, onClick } = this.props;
    if (onClick) {
      onClick(e);
    }


    viewStore.closeDrawer();
  };

  render() {
    const { viewStore, onClick, ...rest } = this.props;

    return (
      <ListItem
        onClick={this.handleClick}
        {...rest}
      />
    );
  }
}

const MODULES = {
  12: 'Tulos',
  13: 'Ostolaskut'
};
@inject('viewStore', 'authStore')
class Company extends Component {


  handleSelect = () => {
    // If the company has password we will have to authenticate before selecting it.
    if (this.props.company.PASSWORD === 1 && this.props.authStore.currentCompany !== this.props.company) {
      // Pass the company to the [LoginDialog].
      this.props.authStore.setTempCompany(this.props.company);
      this.props.viewStore.openLoginDialog();
    }
    else {

      this.props.onSelect(this.props.company);
    }
  };

  modules = () => {
    return this.props.company.modules.map(id => MODULES[id]).join(', ');
  };

  render() {
    return (
      <ListItem button onClick={this.handleSelect}>
        <ListItemText primary={this.props.company.NAME} secondary={this.modules()} />
        {/* If a company has password we will show [LockIcon] in the companies list */}
        {
          this.props.company.PASSWORD === 1 ?
            this.props.company.PASSWORD === 1 && this.props.authStore.currentCompany === this.props.company ?
              <SvgIcon>
                <LockOpenIcon />
              </SvgIcon> :

              <SvgIcon>
                <LockIcon />
              </SvgIcon> : null}
      </ListItem>
    );
  }
}

@inject('authStore', 'viewStore')
@withRouter
@observer
class Drawer extends Component {

  handleCompanySelect = (company) => {
    this.props.authStore.selectCompany(company);
    this.props.viewStore.closeDrawer();
  };

  handleCompanyToggle = (e) => {
    e.preventDefault();
    this.props.viewStore.toggleCompanySelect();
  };

  handleLogout = () => {
    this.props.authStore.logout();
    this.props.history.push('/');
  };

  render() {
    const { authStore, viewStore } = this.props;

    // Content of the drawer menu
    const drawerContent = (
      <div className="col flex no-overflow">
        <div className="drawer-header">
          {/* Opens and closes the list of companies */}
          <a
            onClick={this.handleCompanyToggle}
            href="#cs"
          >

            <div className="drawer-company">
              {/* currentCompany.Name name of the company shown in the drawer menu*/}
              <span>{authStore.currentCompany && authStore.currentCompany.NAME}</span>
              <DropDownIcon className={viewStore.companySelect ? 'icon-rotated' : null} />
            </div>
          </a>
        </div>

        <div className="col flex no-overflow">
          {
            // if company is not selected map [authStore.companies] of companies to list
            viewStore.companySelect ?
              // Custom component [Content]
              <Content
                scroll
                //Shows errors if there is any in errorCompanies and (no authStore.companies or no authStore.companies.lenght)
                error={authStore.errorCompanies && (!authStore.companies || !authStore.companies.length)}
                //Shows loading if there is any in loadingCompanies and (no authStore.companies or no authStore.companies.lenght)
                loading={authStore.loadingCompanies && (!authStore.companies || !authStore.companies.length)}
                onRetry={authStore.fetchCompanies}
              >
                <List>
                  {
                    // It works because in JavaScript, true && expression always evaluates to expression,
                    // and false && expression always evaluates to false.
                    authStore.companies &&
                    authStore.companies.map((company, idx) =>
                      <Company
                        button
                        // If we have a company that has [PASSWORD] property that equals to 1 that means it has password and we need to login to that company.
                        company={company}
                        onSelect={this.handleCompanySelect}
                        key={idx}
                      />
                    )
                  }
                </List>
              </Content> :
              // If company select button is not pressed show list of [DrawerListItem]
              // These items are used to navigate in the app
              <div className="overflow">
                <List>
                  <DrawerListItem button component={Link} to="/tulos">
                    <ListItemIcon>
                      <GraphIcon />
                    </ListItemIcon>
                    <ListItemText primary="Tuloslaskelma" />
                  </DrawerListItem>

                  <DrawerListItem button component={Link} to="/tasevastaavaa">
                    <ListItemIcon>
                      <GraphIcon />
                    </ListItemIcon>
                    <ListItemText primary="Tase vastaavaa" />
                  </DrawerListItem>

                  <DrawerListItem button component={Link} to="/tasevastattavaa">
                    <ListItemIcon>
                      <GraphIcon />
                    </ListItemIcon>
                    <ListItemText primary="Tase vastattavaa" />
                  </DrawerListItem>

                  <DrawerListItem button component={Link} to="/omavero">
                    <ListItemIcon>
                      <SvgIcon>
                        <PercentIcon />
                      </SvgIcon>
                    </ListItemIcon>
                    <ListItemText primary="Omavero" />
                  </DrawerListItem>

                  <DrawerListItem button component={Link} to="/ostolaskut">
                    <ListItemIcon>
                      <OstolaskuIcon />
                    </ListItemIcon>
                    <ListItemText primary="Ostolaskut" />
                  </DrawerListItem>

                  <Divider />

                  <DrawerListItem button component={Link} to="/salasananvaihto">
                    <ListItemIcon>
                      <KeyIcon />
                    </ListItemIcon>
                    <ListItemText primary="Vaihda salasana" />
                  </DrawerListItem>

                  <DrawerListItem button onClick={this.handleLogout}>
                    <ListItemIcon>
                      <LogoutIcon />
                    </ListItemIcon>
                    <ListItemText primary="Kirjaudu ulos" />
                  </DrawerListItem>
                </List>
              </div>
          }
        </div>
      </div>
    );

    return (
      <div>

        {
          /*[Hidden] hides drawer when the size is smaller than md.
          When in large screen doesn't close, but when small screen close.
          [viewStore.drawerOpen] controls if open or closed when in small screen*/}
        <Hidden mdUp>
          <MuiDrawer
            open={viewStore.drawerOpen}
            onClose={viewStore.closeDrawer}
            classes={{ paper: 'drawer' }}
            ModalProps={{
              keepMounted: true,
            }}
          >
            {drawerContent}
          </MuiDrawer>
        </Hidden>

        <Hidden smDown implementation="css">
          <MuiDrawer
            open
            variant="permanent"
            classes={{ paper: 'drawer', docked: 'drawer' }}
          >
            {drawerContent}
          </MuiDrawer>
        </Hidden>
      </div>
    );
  }
}

export default Drawer;
